// extracted by mini-css-extract-plugin
export default {"recovery":"Recovery_recovery__i7B6u","content":"Recovery_content__8-aHi"};